import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { LogoWordmark } from './brand/Brand';

const navItems = [
  { to: '/', label: 'Accueil', exact: true },
  { to: '/recipes', label: 'Recettes' },
  { to: '/budget', label: 'Budget malin', icon: 'ti-coin' },
  { to: '/concours', label: 'Jeu-concours', icon: 'ti-trophy' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [location]);

  const isActive = (item) =>
    item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);

  return (
    <Bar>
      <Inner>
        <LogoWordmark to="/" />

        <Burger onClick={() => setOpen((v) => !v)} aria-label="Menu">
          <i className={open ? 'ti ti-x' : 'ti ti-menu-2'} />
        </Burger>

        <Nav $open={open}>
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={isActive(item) ? 'active' : ''}>
              {item.icon && <i className={`ti ${item.icon}`} aria-hidden="true" />}
              {item.label}
            </NavLink>
          ))}
          <CtaButton to="/add-recipe">
            <i className="ti ti-plus" aria-hidden="true" />
            Ajouter une recette
          </CtaButton>
        </Nav>
      </Inner>
    </Bar>
  );
};

const Bar = styled.header`
  background: ${({ theme }) => theme.colors.light};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Burger = styled.button`
  display: none;
  background: ${({ theme }) => theme.colors.cream};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  width: 44px;
  height: 44px;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  @media (max-width: 880px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 880px) {
    position: fixed;
    inset: 0 0 0 auto;
    width: min(82%, 320px);
    background: ${({ theme }) => theme.colors.light};
    flex-direction: column;
    align-items: stretch;
    padding: 96px 24px 24px;
    gap: 6px;
    box-shadow: ${({ theme }) => theme.shadows.lg};
    transform: ${({ $open }) => ($open ? 'translateX(0)' : 'translateX(110%)')};
    transition: transform ${({ theme }) => theme.transitions.medium};
  }
`;

const NavLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 700;
  font-size: 0.95rem;
  padding: 9px 14px;
  border-radius: ${({ theme }) => theme.borderRadius.pill};
  transition: all ${({ theme }) => theme.transitions.fast};

  i { font-size: 1.05rem; color: ${({ theme }) => theme.colors.secondaryDark}; }

  &:hover {
    background: ${({ theme }) => theme.colors.cream};
    color: ${({ theme }) => theme.colors.primary};
  }
  &.active {
    background: ${({ theme }) => theme.colors.primary};
    color: #fff;
  }
  &.active i { color: ${({ theme }) => theme.colors.secondary}; }
`;

const CtaButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-left: 8px;
  text-decoration: none;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.chocolate};
  font-weight: 800;
  font-size: 0.95rem;
  padding: 10px 18px;
  border-radius: ${({ theme }) => theme.borderRadius.pill};
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.secondaryDark};
    transform: translateY(-1px);
  }
  @media (max-width: 880px) { margin-left: 0; margin-top: 8px; }
`;

export default Header;
